export default "__VITE_ASSET__BmAuT_lS__"